import { onTabLinkClickHandler } from '@pages/product-analyzer/Product';
import { useNavigate } from 'react-router-dom';
import { useAnalytics } from '@ecosystem/newron-client-lib';
import { navigation } from '@ecosystem/newron-design-system';
import React from 'react';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { PageName } from '@utils/pageConfig/Types';
import { BASE_RETAIL_PATH, RETAIL_ALLOWED_PATH } from '@utils/UrlUtils';

interface Props {
  selectedLink: NavigationLinkProps;
  links: NavigationLinkProps[];
  setSelectedLink: any;
  preNavigateAction?: () => void;
}

export interface NavigationLinkProps {
  title: string;
  value: string;
  url: string;
  isDisabled?: boolean;
}

export const TabNav: React.FC<Props> = ({ selectedLink, links, setSelectedLink, preNavigateAction }) => {
  const navigate = useNavigate();
  const { pageName } = usePageConfig();
  const { track } = useAnalytics();

  const getBasePath = (): string => {
    if (pageName === PageName.EXPLORE) return `/${BASE_RETAIL_PATH}/${RETAIL_ALLOWED_PATH.EXPLORE}`;
    if (pageName === PageName.RI_PRODUCT) return `/${BASE_RETAIL_PATH}/${RETAIL_ALLOWED_PATH.PRODUCTS}`;
    if (pageName === PageName.TRADING_ASSISTANT) return `/${BASE_RETAIL_PATH}/${RETAIL_ALLOWED_PATH.TRADING_ASSISTANT}`;
    return '/newron-retail';
  };

  const onLinkClick = (value: string): void => {
    const currentLink = links.find((e) => e.value === value);
    if (!currentLink) return;

    track(`Tab clicked: ${currentLink.value}`);
    if (preNavigateAction) preNavigateAction();

    const basePath = getBasePath();

    onTabLinkClickHandler(currentLink, navigate, setSelectedLink, basePath);
  };

  const toReturn = (linkList: NavigationLinkProps[]) => {
    return linkList.map((link) => {
      return (
        <navigation.SubNavigation.Link key={link.value} value={`${link.url}`}>
          {link.title}
        </navigation.SubNavigation.Link>
      );
    });
  };

  return (
    <div>
      <navigation.SubNavigation defaultValue={selectedLink.url} onChange={onLinkClick}>
        {toReturn(links)}
      </navigation.SubNavigation>
    </div>
  );
};

export default TabNav;
